export const BASE_URL = "https://registration-backend-lime.vercel.app";
